import { FoodBeverageContactType } from '@api';
import { z } from 'zod';

const venueFoodBeverageContactFormSchema = z.object({
  contact: z
    .object({
      personId: z.string(),
      companyId: z.string(),
    })
    .nullable(),
  notes: z.string(),
});

type VenueFoodBeverageContactFormSchemaType =
  typeof venueFoodBeverageContactFormSchema;
export type VenueFoodBeverageContactFormDataType =
  z.infer<VenueFoodBeverageContactFormSchemaType>;

type UseVenueFoodBeverageContactFormSchemaReturnType = {
  schema: VenueFoodBeverageContactFormSchemaType;
  defaultValues: VenueFoodBeverageContactFormDataType;
};

export const useVenueFoodBeverageContactFormSchema = (
  venueFoodBeverageContact: FoodBeverageContactType
): UseVenueFoodBeverageContactFormSchemaReturnType => {
  const defaultValues: VenueFoodBeverageContactFormDataType = {
    contact: venueFoodBeverageContact.contact,
    notes: venueFoodBeverageContact.notes ?? '',
  };

  return { schema: venueFoodBeverageContactFormSchema, defaultValues };
};
